/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Reasons for slashing staked tokens */
export enum SlashReason {
  Fraud,
  DisputeLoss,
  Custom,
}

export type SlashReasonArgs = SlashReason;

export function getSlashReasonEncoder(): FixedSizeEncoder<SlashReasonArgs> {
  return getEnumEncoder(SlashReason);
}

export function getSlashReasonDecoder(): FixedSizeDecoder<SlashReason> {
  return getEnumDecoder(SlashReason);
}

export function getSlashReasonCodec(): FixedSizeCodec<
  SlashReasonArgs,
  SlashReason
> {
  return combineCodec(getSlashReasonEncoder(), getSlashReasonDecoder());
}
